import styled from 'styled-components';
import Colours from '../State/Colours';

export default styled<{ enabled: boolean, rowNumber?: number }, 'div'>('div')`
    align-self: center;
    -ms-grid-row-align: center;
    color: ${({ enabled }) => enabled === true ? Colours.primary : Colours.gray}; 
    text-align: right;
    ${({ rowNumber }) => !!rowNumber ? `-ms-grid-row: ${rowNumber}` : ''}
`;


// WEBPACK FOOTER //
// ./src/Components/Total.tsx